// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__3Rt98","content":"carousel_content__1A2TT","control":"carousel_control__KFZmW"};